class BenefitTypeDescriptionModalCtrl {
  close() {
    this.modalInstance.dismiss();
  }
}

export default BenefitTypeDescriptionModalCtrl;
